import { render } from "./BoletoGarantido.vue?vue&type=template&id=3cbb63d8&scoped=true"
import script from "./BoletoGarantido.vue?vue&type=script&lang=js"
export * from "./BoletoGarantido.vue?vue&type=script&lang=js"

import "./BoletoGarantido.vue?vue&type=style&index=0&id=3cbb63d8&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbb63d8"]])

export default __exports__